import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import ProductTable from "./Table/ProductTable";
import { getAllProducts, deleteProducts } from "../../api/productAPI";
import { toast } from "react-toastify";
import {
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  Button as MUIButton
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Delete as DeleteIcon } from '@mui/icons-material'; // Icon for loading button
import { useNavigate } from "react-router-dom";

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filter, setFilter] = useState("all");

  const [showDeleteDialog, setShowDeleteDialog] = useState(false); 
  const [deletingProductId, setDeletingProductId] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate()

  useEffect(() => {
    const fetchProducts = async () => {
      const fetchedProducts = await getAllProducts();
      setProducts(fetchedProducts);
      setFilteredProducts(fetchedProducts);
    };

    fetchProducts();
  }, []);



  const handleDeleteConfirmation = (id) => {
    setDeletingProductId(id);
    setShowDeleteDialog(true); // Show confirmation dialog
  };

  const confirmDelete = async () => {
    setLoading(true); // Start loading

    setTimeout(async () => {
      try {
        await deleteProducts(deletingProductId);
        setProducts(products.filter(p => p._id !== deletingProductId));
        setFilteredProducts(filteredProducts.filter(p => p._id !== deletingProductId));
        setShowDeleteDialog(false); 
        toast.success("Product deleted successfully!");
      } catch (error) {
        toast.error("Failed to delete product.");
      } finally {
        setLoading(false); // Stop loading
      }
    }, 2000); // 2-second delay for loader
  };

  const handleFilterChange = (event) => {
    const selectedFilter = event.target.value;
    setFilter(selectedFilter);

    if (selectedFilter === "all") {
      setFilteredProducts(products);
    } else {
      setFilteredProducts(products.filter(product => product.category === selectedFilter));
    }
  };

  return (
    <div>
      <Row className="mb-3">
        <Col>
          <h2>Product List</h2>
        </Col>

        <Col className='text-right'>
          <Button className='my-3 w-50 float-end' onClick={() =>{
            navigate('/products/create')
          }}>
            <i className='fas fa-plus me-2' />
            Create Product
          </Button>
        </Col>
      </Row>

      <ProductTable
        products={filteredProducts}
        onDelete={handleDeleteConfirmation} // Show confirmation dialog on delete
      />

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={showDeleteDialog}
        onClose={() => setShowDeleteDialog(false)}
      >
        <DialogTitle>Delete Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this product? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MUIButton onClick={() => setShowDeleteDialog(false)} color="primary">
            Cancel
          </MUIButton>
          {/* LoadingButton for confirming delete */}
          <LoadingButton
            loading={loading}
            loadingPosition="start"
            startIcon={<DeleteIcon />}
            variant="outlined"
            onClick={confirmDelete}
            color="error"
          >
            Delete
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ProductList;
